import React from 'react';

import Element, { CommonProps } from '../../Element/Element';
import styles from '../List.module.scss';

export type ListItemProps = CommonProps<'li'>;
const ListItem: React.FunctionComponent<ListItemProps> = ({
  margin = { bottom: 'xs' },
  children,
  ...props
}) => {
  return (
    <Element
      tagName="li"
      className={styles.list_item}
      margin={margin}
      {...props}
    >
      {children}
    </Element>
  );
};

export default ListItem;
